import React from 'react'
import PropTypes from 'prop-types'
import { Drawer, Space, Button } from 'antd'

export const TDrawer = ({ isOpen, children, onResolve, styles, ...props }) => {
  return (
    <Drawer
      placement="left"
      className="t-drawer"
      width="100vw"
      onClose={onResolve}
      open={isOpen}
      styles={{
        body: { padding: 0 },
        header: { padding: '5px' },
        ...styles
      }}
      {...props}
      extra={
        <Space>
          <Button onClick={onResolve}>OK</Button>
        </Space>
      }
    >
      {children}
    </Drawer>
  )
}

TDrawer.displayName = 'TDrawer'
TDrawer.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onResolve: PropTypes.func.isRequired,
  styles: PropTypes.shape({})
}

export default TDrawer
